import { useI18n } from '@namespace/i18n';
import {
  Deposit as CoreDeposit,
  PAYMENT_SYSTEMS,
  Payments
} from '@namespace/payments';

const projectPaymentSystemsMap = {
  [PAYMENT_SYSTEMS.CASHDESK]: Payments
};

const Deposit = ({ id }) => {
  const { t } = useI18n();

  return (
    <CoreDeposit
      id={id}
      projectPaymentSystemsMap={projectPaymentSystemsMap}
      title={t('personalOffice.balance.deposit.title')}
    />
  );
};

export default Deposit;
